<template>
  <div id="app">
    <div id="main-content">
      <router-view />
    </div>
    <notifications
      group="notification"
      position="bottom right"
      width="325"
      animation-type="velocity"
    />
  </div>
</template>

<script>
import "@/plugins/vue-cookies";
import "@/plugins/vue-head";

window.onbeforeunload = function() {
  localStorage.clear();
  this.$cookies.remove("UnileverId");
};
export default {
  name: "app",
  created: function() {
    localStorage.clear();
    this.$cookies.remove("UnileverID");
  },
  data() {
    return {
      digitalDataEvent: null
    }
  },
  computed: {
    destinationUrl: {
      get() {
        return `${window.location.host}${this.$route.path}`;
      },
      set(url) {
        return url;
      }
    },
    reportSuiteId: {
      get() {
        const env = process.env.VUE_APP_MODE;
        return env === 'Production'
          ? 'unileverapac-unileverbrandrange-ph,unileverapac-global-allbrands'
          : 'unileverapac-unileverbrandrange-ph-uat,unileverapac-allbrands-uat';
      },
      set(id) {
        return id;
      }
    },
    digitalDataLayer: {
      get() {
        /* eslint-disable */
        const isMobile = function() {
          let check = false;
          (function(a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
              .test(a)
              || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
              .test(a.substr(0, 4))) {
              check = true;
            }
          })(navigator.userAgent || navigator.vendor || window.opera);
          return check;
        };
        /* eslint-enable */
        let channelVal;
        if (isMobile()) {
          channelVal = "Mobile Site";
        } else {
          channelVal = "Brand Site";
        }
        return {
          siteInfo: {
            channel: channelVal,
            sitetype: "Non-D2",
            internalDomain: ""
          },
          page: {
            pageInfo: {
              destinationURL: this.destinationUrl,
              pageName: this.$route.name,
              language: "en-PH"
            },
            category: {
              pageType: this.$route.name,
              primaryCategory: channelVal
            },
            attributes: {
              contentType: this.$route.name,
              brandCategory: "Multi-Category",
              country: "PH",
              globalBrand: "Unilever Brand Range",
              localBrand: "Unilever Brand Range"
            }
          },
          video: [],
          campaign: [],
          product: [],
          privacy: {
            accessCategories: [ {
              domains: []
            } ]
          },
          component: [],
          trackingInfo: {
            GID: "",
            un: "",
            tool: [
              { id: "UA-212252632-3,G-LHXM6LQM1C" }, // GA TRACKING ID
              { id: this.reportSuiteId } // Adobe Report Suite ID
            ]
          },
          promotion: []
        }
      },
      set(data) {
        return data;
      }
    }
  },
  head: {
    script: function() {
      return this.$route.params.subdomain === 'ucoin'
        ? [
          { type: 'text/javascript', src: '//assets.adobedtm.com/e6bd1902389a/064a636dbf94/launch-ea234d601bc9.min.js', async: '', id: 'adobe-launcher' }
        ]
        : null;
    }
  },
  mounted() {
    this.injectAdobeAnalytics();
    this.$root.$on('reinjectAdobeAnalytics', () => this.reinjectAdobeAnalytics());
    this.$root.$on('pushDigitalDataEvent', (eventData) => {
      window.digitalData['event'].push && window.digitalData['event'].push(eventData);
    });
  },
  beforeDestroy() {
    this.$root.$off('reinjectAdobeAnalytics');
    this.$root.$off('pushDigitalDataEvent');
  },
  methods: {
    injectAdobeAnalytics() {
      const subdomain = this.$route.params.subdomain;
      if (subdomain && subdomain === 'ucoin') {
        const scriptFunction = document.createElement('script');
        scriptFunction.append('(function(g,b,d,f){(function(a,c,d){if(a){var e=b.createElement("style");e.id=c;e.innerHTML=d;a.appendChild(e)}})(b.getElementsByTagName("head")[0],"at-body-style",d);setTimeout(function(){var a=b.getElementsByTagName("head")[0];if(a){var c=b.getElementById("at-body-style");c&&a.removeChild(c)}},f)})(window,document,"body {opacity: 0 !important}",3E3);');
        scriptFunction.setAttribute('id', 'script-function');

        const adobeDataLayer = document.createElement('script');
        const transformAdobeDataLayer = `digitalData = ${JSON.stringify(this.digitalDataLayer)}`;
        adobeDataLayer.append(transformAdobeDataLayer);
        adobeDataLayer.setAttribute('id', 'adobe-datalayer');

        this.$nextTick(() => {
          if(!document.getElementById('script-function')) document.head.insertBefore(scriptFunction, document.getElementById('adobe-launcher'));
          if(!document.getElementById('adobe-datalayer')) document.head.insertBefore(adobeDataLayer, document.getElementById('adobe-launcher'));
        });
      }
    },
    reinjectAdobeAnalytics() {
      const adobeDataLayer = document.createElement('script');
      const transformAdobeDataLayer = `digitalData = ${JSON.stringify(this.digitalDataLayer)}`;
      adobeDataLayer.append(transformAdobeDataLayer);
      adobeDataLayer.setAttribute('id', 'adobe-datalayer');

      const dataLayerScript = document.getElementById('adobe-datalayer');
      if (dataLayerScript) {
        dataLayerScript.remove();
        this.$nextTick(() => {
          document.head.insertBefore(adobeDataLayer, document.getElementById('adobe-launcher'));
        });
      }
    }
  },
  watch: {
    "$route": function() {
      this.reinjectAdobeAnalytics();
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/app.scss";
</style>
